var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "mobile-multiselect",
    _vm._g(
      _vm._b(
        {
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(slotProps) {
                return _vm._l(slotProps.options, function(option) {
                  return _c("mobile-multiselect-item-color", {
                    key: option.id,
                    attrs: {
                      title: option.label,
                      "is-selected": slotProps.isSelected(option),
                      color: option.hex
                    },
                    nativeOn: {
                      click: function($event) {
                        return slotProps.toggle(option)
                      }
                    }
                  })
                })
              }
            }
          ])
        },
        "mobile-multiselect",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }